import React from "react";
import { useStore, useSelector } from "react-redux";
import { Cartesian3 } from "cesium";
import { BillboardCollection, Billboard } from "resium";

function StartEndPoint() {
  const { select } = useStore();
  const startPosition = useSelector(select.layer.selectStartPoint);
  const endPosition = useSelector(select.layer.selectEndPoint);
  return (
    <BillboardCollection>
      {startPosition && (
        <Billboard
          key={`billboard-start-point`}
          position={Cartesian3.fromDegrees(startPosition[0], startPosition[1])}
          image="/navigate/images/start.png"
          zIndex={3000}
        />
      )}
      {endPosition && (
        <Billboard
          key={`billboard-end-point`}
          position={Cartesian3.fromDegrees(endPosition[0], endPosition[1])}
          image="/navigate/images/end.png"
          zIndex={3000}
        />
      )}
    </BillboardCollection>
  );
}

export default StartEndPoint;
